import { render, staticRenderFns } from "./Avaliacao.vue?vue&type=template&id=f3c80992&scoped=true&"
import script from "./Avaliacao.vue?vue&type=script&lang=js&"
export * from "./Avaliacao.vue?vue&type=script&lang=js&"
import style0 from "./Avaliacao.vue?vue&type=style&index=0&id=f3c80992&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c80992",
  null
  
)

export default component.exports